module.exports = __webpack_public_path__ + "media/images/riders/RUDY_CABIROU-3b29bc28f04a039390a96de93a60f837.png";